/**
 * PoweredByHotelbeds — reusable Hotelbeds attribution chip.
 *
 * Appears on results cards, hotel detail, booking form, confirmation,
 * and My Booked Trips items sourced from Hotelbeds. Small pill, navy
 * outlined, unobtrusive but always visible so users know who's
 * fulfilling the booking (Hotelbeds cert requirement).
 */
import React from "react";
import { Hotel } from "lucide-react";

export default function PoweredByHotelbeds({ size = "sm", className = "" }) {
  const isXs = size === "xs";
  return (
    <span
      data-testid="powered-by-hotelbeds"
      className={
        "inline-flex items-center gap-1.5 rounded-full border border-tb-navy/40 " +
        "bg-white/85 text-tb-navy backdrop-blur-[2px] " +
        (isXs ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-[11px]") +
        " " + className
      }
      style={{ fontFamily: '"Outfit", sans-serif' }}
    >
      <Hotel className={isXs ? "w-3 h-3" : "w-3.5 h-3.5"} strokeWidth={1.9} />
      <span className="tracking-wide uppercase">Powered by Hotelbeds</span>
    </span>
  );
}
